/**
 * @flow
 * @relayHash d10b7e0a25e49bfd52dad3790b06c764
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplateContainer_node$ref = any;
type MpTemplateContainer_viewer$ref = any;
export type TemplateRoutes_MpTemplate_QueryVariables = {|
  id: string
|};
export type TemplateRoutes_MpTemplate_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: MpTemplateContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: MpTemplateContainer_viewer$ref
  |},
|};
export type TemplateRoutes_MpTemplate_Query = {|
  variables: TemplateRoutes_MpTemplate_QueryVariables,
  response: TemplateRoutes_MpTemplate_QueryResponse,
|};
*/


/*
query TemplateRoutes_MpTemplate_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...MpTemplateContainer_node
    id
  }
  viewer {
    ...MpTemplateContainer_viewer
    id
  }
}

fragment MpTemplateContainer_node on MpTemplate {
  id
  title
  description
  notes
  can_edit
  public
  brand {
    id
    logo_url
    header
  }
  mp_template_playlists(first: 99999) {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment MpTemplateContainer_viewer on User {
  id
  first_name
  last_name
  primary_brand {
    id
    header
    logo_url
  }
  ...MpTemplatePlaylistContainer_viewer
  ...SearchContainer_viewer
}

fragment MpTemplatePlaylistContainer_viewer on User {
  id
  playlists(first: 99999) {
    edges {
      node {
        id
        can_edit
        title
        description
        num_songs
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  public_playlists(first: 99999) {
    edges {
      node {
        id
        can_edit
        title
        description
        num_songs
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
      }
    }
  }
}

fragment SearchContainer_viewer on User {
  s_time_zone
  user_event_search(first: 3, query: "") {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "can_edit",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "logo_url",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "header",
  "args": null,
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "thumbnail",
  "storageKey": "thumbnail(height:240,width:240)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }
  ],
  "concreteType": "SongImage",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    },
    v3
  ]
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "num_songs",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "TemplateRoutes_MpTemplate_Query",
  "id": null,
  "text": "query TemplateRoutes_MpTemplate_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...MpTemplateContainer_node\n    id\n  }\n  viewer {\n    ...MpTemplateContainer_viewer\n    id\n  }\n}\n\nfragment MpTemplateContainer_node on MpTemplate {\n  id\n  title\n  description\n  notes\n  can_edit\n  public\n  brand {\n    id\n    logo_url\n    header\n  }\n  mp_template_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MpTemplateContainer_viewer on User {\n  id\n  first_name\n  last_name\n  primary_brand {\n    id\n    header\n    logo_url\n  }\n  ...MpTemplatePlaylistContainer_viewer\n  ...SearchContainer_viewer\n}\n\nfragment MpTemplatePlaylistContainer_viewer on User {\n  id\n  playlists(first: 99999) {\n    edges {\n      node {\n        id\n        can_edit\n        title\n        description\n        num_songs\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  public_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        can_edit\n        title\n        description\n        num_songs\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SearchContainer_viewer on User {\n  s_time_zone\n  user_event_search(first: 3, query: \"\") {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TemplateRoutes_MpTemplate_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "MpTemplateContainer_node",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "MpTemplateContainer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TemplateRoutes_MpTemplate_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "InlineFragment",
            "type": "MpTemplate",
            "selections": [
              v4,
              v5,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "public",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "brand",
                "storageKey": null,
                "args": null,
                "concreteType": "Brand",
                "plural": false,
                "selections": [
                  v3,
                  v7,
                  v8
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mp_template_playlists",
                "storageKey": "mp_template_playlists(first:99999)",
                "args": v9,
                "concreteType": "MpTemplatePlaylistConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MpTemplatePlaylistEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MpTemplatePlaylist",
                        "plural": false,
                        "selections": [
                          v3,
                          v4,
                          v5,
                          v10,
                          v11,
                          v2
                        ]
                      },
                      v12
                    ]
                  },
                  v13
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "mp_template_playlists",
                "args": v9,
                "handle": "connection",
                "key": "MpTemplateContainer_mp_template_playlists",
                "filters": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v3,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "primary_brand",
            "storageKey": null,
            "args": null,
            "concreteType": "Brand",
            "plural": false,
            "selections": [
              v3,
              v8,
              v7
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlists",
            "storageKey": "playlists(first:99999)",
            "args": v9,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Playlist",
                    "plural": false,
                    "selections": [
                      v3,
                      v6,
                      v4,
                      v5,
                      v11,
                      v10,
                      v2
                    ]
                  },
                  v12
                ]
              },
              v13
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "playlists",
            "args": v9,
            "handle": "connection",
            "key": "MpTemplateContainer_playlists",
            "filters": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "public_playlists",
            "storageKey": "public_playlists(first:99999)",
            "args": v9,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Playlist",
                    "plural": false,
                    "selections": [
                      v3,
                      v6,
                      v4,
                      v5,
                      v11,
                      v10
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_search",
            "storageKey": "user_event_search(first:3,query:\"\")",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "query",
                "value": "",
                "type": "String!"
              }
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEvent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                          v3,
                          v4
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "booking_status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "start_at",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "end_at",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_event_segments",
                        "storageKey": "user_event_segments(first:1)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1,
                            "type": "Int"
                          }
                        ],
                        "concreteType": "UserEventSegmentConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserEventSegmentEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "location",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v3
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v3
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2676f8a2b74f1966bd6bc682f3fb0c6b';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/TemplateRoutes_MpTemplate_Query.graphql.js